import { render } from "./ASide.vue?vue&type=template&id=229658a0"
import script from "./ASide.vue?vue&type=script&lang=js"
export * from "./ASide.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__